import React from "react";
//import TopHeader from "../../Homepage/component/TopHeader";
import Navbar from "../../Homepage/component/Navbar";
import TeamMemberProfile from "../components/TeamMemberProfile";
//import MeetThePros from "../components/TeamMember_Friends";
import Footer from "../../faq/component/Footer";

import { useParams } from "react-router-dom";


const ProfilePage = () => {
  const { name } = useParams();
  return (
    <div className="relative">
   
      <Navbar />
      <div className="mt-12">
        <TeamMemberProfile name={name} />
      </div>
      
      <Footer />
    </div>
  );
};

export default ProfilePage;
